export const LOCALIZATION_FILE_SOURCE_FILE = 'file';
export const LOCALIZATION_FILE_SOURCE_INHERIT = 'inherit';
export const LOCALIZATION_FILE_FORMAT_HTML = 'html';
export const LOCALIZATION_FILE_STORAGE_FORMAT_JSON = 'json';

const manifestCache = new Map();
const localizationFileCache = new Map();

const LOCALIZATION_FILE_DEFINITIONS = {
  faq: {
    label: 'FAQ',
    description: '',
    format: LOCALIZATION_FILE_FORMAT_HTML,
    systemDefaults: {
      en: [
        '<h4>How do I get my pictures and videos?</h4>',
        '<p>We use state of the art face recognition technology that will find photos and videos we made of you and your party throughout your experience. To take advantage of this feature, you must register portrait photos (selfies) of each member of your party.</p>',
        '<h4>What does a Storibox Pass include?</h4>',
        '<p>With a Storibox Pass, you may</p>',
        '<ul><li>Download and save high-resolution images and videos, based on which package you purchased.</li><li>Instantly share your signature memories with your friends and family.</li><li>Access your content for up to 60 days post your visit.</li></ul>',
        '<h4>I have purchased a Storibox Pass. When can I begin downloading my photos?</h4>',
        '<p>With a Storibox Pass, you may begin downloading as soon as photos are available in your account. You may choose to download them immediately or after your trip, because the photos will be available for up to 60 days from the day of your visit.</p>',
        '<h4>I have not decided to get a Storibox Pass. Can I still view my images?</h4>',
        '<p>If you did not purchase a digital pass, you can still preview your images, but they will be watermarked.</p>',
      ].join(''),
      es: [
        '<h4>¿Cómo obtengo mis fotos y videos?</h4>',
        '<p>Usamos tecnología de reconocimiento facial de última generación para encontrar las fotos y los videos que tomamos de ti y de tu grupo durante toda la experiencia. Para aprovechar esta función, debes registrar fotos de retrato (selfies) de cada miembro de tu grupo.</p>',
        '<h4>¿Qué incluye un Storibox Pass?</h4>',
        '<p>Con un Storibox Pass puedes:</p>',
        '<ul><li>Descargar y guardar fotos y videos en alta resolución, según el paquete que hayas comprado.</li><li>Compartir al instante tus recuerdos favoritos con tus amigos y familiares.</li><li>Crear fotos personalizadas con productos seleccionados e imprimirlas al momento.</li><li>Acceder a tu contenido hasta 60 días después de tu visita, para que puedas comprar recuerdos adicionales más adelante.</li></ul>',
        '<h4>Ya compré un Storibox Pass. ¿Cuándo puedo empezar a descargar mis fotos?</h4>',
        '<p>Con un Storibox Pass, puedes comenzar a descargar tan pronto como las fotos estén disponibles en tu cuenta. Puedes descargarlas de inmediato o después de tu viaje, porque estarán disponibles hasta 60 días desde la fecha de tu visita.</p>',
        '<h4>Todavía no decido si comprar un Storibox Pass. ¿Aun así puedo ver mis imágenes?</h4>',
        '<p>Si no compraste un pase digital, aún puedes previsualizar tus imágenes, pero tendrán marca de agua.</p>',
        '<h4>¿Dónde puedo recoger los productos que compré?</h4>',
        '<p>Consulta al personal del lugar para conocer el punto de venta y recogida de mercancía.</p>',
        '<h4>¿Puedo recibir en casa la mercancía que compré?</h4>',
        '<p>Sí. Solo proporciona una dirección y nuestro socio de entregas llevará tu compra a tu hogar. Este servicio está disponible durante 60 días después de tu visita.</p>',
      ].join(''),
      fr: [
        '<h4>Comment puis-je récupérer mes photos et vidéos ?</h4>',
        '<p>Nous utilisons une technologie de reconnaissance faciale de pointe qui retrouvera les photos et vidéos prises de vous et de votre groupe tout au long de votre expérience. Pour profiter de cette fonctionnalité, vous devez enregistrer des photos portrait (selfies) de chaque membre de votre groupe.</p>',
        '<h4>Que comprend un Pass Storibox ?</h4>',
        '<p>Avec un Pass Storibox, vous pouvez</p>',
        '<ul><li>Télécharger et enregistrer des images et vidéos en haute résolution, selon le forfait que vous avez acheté.</li><li>Partager instantanément vos souvenirs inoubliables avec vos proches.</li><li>Accéder à votre contenu jusqu\'à 60 jours après votre visite.</li></ul>',
        '<h4>J\'ai acheté un Pass Storibox. Quand puis-je commencer à télécharger mes photos ?</h4>',
        '<p>Avec un Pass Storibox, vous pouvez commencer à télécharger dès que les photos sont disponibles dans votre compte. Vous pouvez choisir de les télécharger immédiatement ou après votre voyage, car elles resteront disponibles jusqu\'à 60 jours à compter du jour de votre visite.</p>',
        '<h4>Je n\'ai pas encore décidé de prendre un Pass Storibox. Puis-je quand même voir mes images ?</h4>',
        '<p>Si vous n\'avez pas acheté de pass numérique, vous pouvez tout de même prévisualiser vos images, mais elles seront filigranées.</p>',
      ].join(''),
      ja: [
        '<h4>写真や動画はどのように受け取れますか？</h4>',
        '<p>当社では、最先端の顔認識技術を使用して、体験中に撮影されたあなたと同行者の写真・動画を見つけます。この機能を利用するには、同行者それぞれの顔写真（セルフィー）を登録してください。</p>',
        '<h4>Storibox Pass には何が含まれますか？</h4>',
        '<p>Storibox Pass を利用すると、次のことができます。</p>',
        '<ul><li>高解像度の写真と動画をダウンロードして保存できます。</li><li>大切な思い出を友人や家族とすぐに共有できます。</li><li>対象商品でオリジナル写真を作成し、その場で印刷できます。</li><li>来場後60日間コンテンツにアクセスできるため、あとから追加の記念商品を購入することもできます。</li></ul>',
        '<h4>Storibox Pass を購入しました。写真のダウンロードはいつからできますか？</h4>',
        '<p>Storibox Pass では、写真がアカウントに表示され次第すぐにダウンロードできます。すぐにダウンロードすることも、旅行後にダウンロードすることも可能です。写真は来場日から最大60日間利用できます。</p>',
        '<h4>Storibox Pass を購入するかまだ決めていません。画像は見られますか？</h4>',
        '<p>デジタルパスを購入していない場合でも画像をプレビューできますが、透かし（ウォーターマーク）が表示されます。</p>',
        '<h4>購入した商品はどこで受け取れますか？</h4>',
        '<p>商品販売場所については、現地スタッフまでお声がけください。</p>',
        '<h4>購入した商品を自宅へ配送することはできますか？</h4>',
        '<p>はい。住所をご提供いただくだけで、配送業者がご購入品をご自宅までお届けします。このサービスは来場後60日間ご利用いただけます。</p>',
      ].join(''),
      zht: [
        '<h4>我該如何取得我的照片與影片？</h4>',
        '<p>我們使用先進的人臉辨識技術，為您找出在整個體驗過程中拍攝的您與同行者的照片和影片。若要使用此功能，您需要為每位同行者註冊人像照片（自拍）。</p>',
        '<h4>Storibox Pass 包含哪些內容？</h4>',
        '<p>使用 Storibox Pass，您可以：</p>',
        '<ul><li>下載並儲存高解析度照片與影片。</li><li>立即與親友分享精彩回憶。</li><li>使用可選商品製作個人化照片並即時列印。</li><li>在造訪後 60 天內持續存取您的內容，讓您日後仍可購買更多紀念商品。</li></ul>',
        '<h4>我已購買 Storibox Pass，何時可以開始下載照片？</h4>',
        '<p>購買 Storibox Pass 後，只要照片出現在您的帳戶中即可開始下載。您可以立即下載，也可以在行程結束後再下載；照片自造訪日起最多可保留 60 天。</p>',
        '<h4>我還沒決定是否購買 Storibox Pass，仍然可以查看圖片嗎？</h4>',
        '<p>若您尚未購買數位通行證，仍可預覽圖片，但圖片會加上浮水印。</p>',
        '<h4>我可以在哪裡領取已購買的商品？</h4>',
        '<p>請向現場工作人員詢問商品銷售與領取地點。</p>',
        '<h4>我可以將已購買的商品寄送到家嗎？</h4>',
        '<p>可以。只要提供地址，我們的配送夥伴將把您的購物內容送到府上。此服務於造訪後 60 天內提供。</p>',
      ].join(''),
      zhs: [
        '<h4>我如何获取我的照片和视频？</h4>',
        '<p>我们使用先进的人脸识别技术，帮助您找到在整个体验过程中拍摄的您和同行人员的照片与视频。要使用此功能，您需要为同行的每位成员注册肖像照片（自拍）。</p>',
        '<h4>Storibox Pass 包含哪些内容？</h4>',
        '<p>使用 Storibox Pass，您可以：</p>',
        '<ul><li>下载并保存高分辨率照片和视频。</li><li>即时与亲友分享精彩回忆。</li><li>使用可选商品制作个性化照片并立即打印。</li><li>在到访后 60 天内继续访问您的内容，让您之后仍可购买更多纪念商品。</li></ul>',
        '<h4>我已购买 Storibox Pass，何时可以开始下载照片？</h4>',
        '<p>购买 Storibox Pass 后，只要照片出现在您的账户中，您即可开始下载。您可以立即下载，也可以在行程结束后再下载；照片自到访日起最长保留 60 天。</p>',
        '<h4>我还没决定是否购买 Storibox Pass，还能查看图片吗？</h4>',
        '<p>如果您尚未购买数字通行证，仍可预览图片，但图片会带有水印。</p>',
        '<h4>我可以在哪里领取已购买的商品？</h4>',
        '<p>请向现场工作人员咨询商品销售和领取地点。</p>',
        '<h4>我可以把已购买的商品寄送到家吗？</h4>',
        '<p>可以。只需提供地址，我们的配送伙伴会将您的购物内容送到家门口。此服务在到访后 60 天内可用。</p>',
      ].join(''),
    },
  },
  privacy: {
    label: 'Terms and Conditions',
    description: '',
    format: LOCALIZATION_FILE_FORMAT_HTML,
    systemDefaults: {
      en: '',
      es: '',
      fr: '',
      ja: '',
      zht: '',
      zhs: '',
    },
  },
};

/**
 * Returns the registry for the standalone localization-files system.
 *
 * Example input:
 * - no arguments
 *
 * Example output:
 * - an array with `faq` and `privacy` definitions
 *
 * Edge cases:
 * - returns an empty array if no large content items are registered
 */
export function getLocalizationFileDefinitions() {
  return Object.entries(LOCALIZATION_FILE_DEFINITIONS).map(([contentId, definition]) => ({
    contentId,
    ...definition,
  }));
}

/**
 * Returns a single localization-files definition by content id.
 *
 * Example input:
 * - `contentId = 'faq'`
 *
 * Example output:
 * - the FAQ definition object
 *
 * Edge cases:
 * - returns `null` when the content id is not registered
 */
export function getLocalizationFileDefinition(contentId) {
  const definition = LOCALIZATION_FILE_DEFINITIONS[contentId];
  return definition ? { contentId, ...definition } : null;
}

/**
 * Returns repo-owned fallback HTML for a localization file.
 *
 * Example input:
 * - `contentId = 'privacy'`
 * - `language = 'fr-CA'`
 *
 * Example output:
 * - French privacy HTML fallback
 *
 * Edge cases:
 * - falls back to English when the requested language is not defined
 * - returns an empty string when the content id is unknown
 */
export function getSystemDefaultLocalizationFile({ contentId, language }) {
  const normalizedLanguage = normalizeLanguage(language);
  const definition = LOCALIZATION_FILE_DEFINITIONS[contentId];

  if (!definition) {
    return '';
  }

  return definition.systemDefaults[normalizedLanguage] ?? definition.systemDefaults.en ?? '';
}

export function buildLocalizationFilesManifestFolderPath({ orgId }) {
  return `${orgId}/localization-files/`;
}

export function buildLocalizationFilesManifestRelativePath({ orgId }) {
  return `${buildLocalizationFilesManifestFolderPath({ orgId })}manifest.json`;
}

export function buildLocalizationFileFolderPath({ orgId, eventCode = 'global', language }) {
  const normalizedLanguage = normalizeLanguage(language);
  return `${orgId}/localization-files/${getScopePath(eventCode)}/${normalizedLanguage}/`;
}

export function buildLocalizationFileRelativePath({ orgId, eventCode = 'global', language, contentId }) {
  return `${buildLocalizationFileFolderPath({ orgId, eventCode, language })}${contentId}.${LOCALIZATION_FILE_STORAGE_FORMAT_JSON}`;
}

export function getLocalizationFilesManifestUrl(params) {
  return `${process.env.LOCALIZATION_CDN}/${buildLocalizationFilesManifestRelativePath(params)}`;
}

export function getLocalizationFileUrl(params) {
  return `${process.env.LOCALIZATION_CDN}/${buildLocalizationFileRelativePath(params)}`;
}

/**
 * Fetches a manifest that describes whether each content id inherits or uses its own file.
 *
 * Example input:
 * - `orgId = 12`
 *
 * Example output:
 * - `{ faq: { global: { en: { source: 'file', format: 'html' } }, wmww: { fr: { source: 'file' } } } }`
 *
 * Edge cases:
 * - returns `{}` on 404, invalid JSON, or network errors
 */
export async function fetchLocalizationFilesManifest(
  { orgId },
  { fetcher = globalThis.fetch, force = false } = {}
) {
  if (typeof fetcher !== 'function') {
    return {};
  }

  const cacheKey = String(orgId);

  if (!force && manifestCache.has(cacheKey)) {
    return manifestCache.get(cacheKey);
  }

  const manifestPromise = (async () => {
    try {
      const response = await fetcher(getLocalizationFilesManifestUrl({ orgId }), {
        method: 'GET',
        cache: 'no-cache',
        mode: 'cors',
      });

      if (!response.ok) {
        return {};
      }

      const data = await response.json();
      return normalizeManifest(data);
    } catch (error) {
      console.error(`Error fetching localization files manifest for organisation "${orgId}":`, error);
      return {};
    }
  })();

  manifestCache.set(cacheKey, manifestPromise);

  return manifestPromise;
}

/**
 * Fetches stored HTML content for a localization file.
 *
 * Example input:
 * - `orgId = 12`
 * - `eventCode = 'global'`
 * - `language = 'en'`
 * - `contentId = 'faq'`
 *
 * Example output:
 * - stored HTML string for that exact scope
 *
 * Edge cases:
 * - returns an empty string when the file does not exist or cannot be fetched
 */
export async function fetchStoredLocalizationFile(
  { orgId, eventCode = 'global', language, contentId },
  { fetcher = globalThis.fetch, force = false } = {}
) {
  if (typeof fetcher !== 'function') {
    return '';
  }

  const cacheKey = `${orgId}:${eventCode || 'global'}:${normalizeLanguage(language)}:${contentId}`;

  if (!force && localizationFileCache.has(cacheKey)) {
    return localizationFileCache.get(cacheKey);
  }

  const filePromise = (async () => {
    try {
      const response = await fetcher(getLocalizationFileUrl({ orgId, eventCode, language, contentId }), {
        method: 'GET',
        cache: 'no-cache',
        mode: 'cors',
      });

      if (!response.ok) {
        return '';
      }

      const rawBody = await response.text();
      return parseStoredLocalizationFile(rawBody);
    } catch (error) {
      console.error(`Error fetching localization file "${contentId}":`, error);
      return '';
    }
  })();

  localizationFileCache.set(cacheKey, filePromise);

  return filePromise;
}

export function getManifestEntry({ manifest = {}, eventCode = 'global', contentId, language }) {
  const normalizedLanguage = normalizeLanguage(language);
  const scopeKey = eventCode || 'global';
  return manifest?.[contentId]?.[scopeKey]?.[normalizedLanguage] || {
    source: LOCALIZATION_FILE_SOURCE_INHERIT,
    hasContent: false,
  };
}

/**
 * Resolves HTML content through event -> global -> system default fallback.
 *
 * Example input:
 * - `orgId = 12`
 * - `eventCode = 'wmww'`
 * - `language = 'fr'`
 * - `contentId = 'privacy'`
 *
 * Example output:
 * - resolved HTML string for runtime rendering
 *
 * Edge cases:
 * - `source = inherit` falls through to the next layer
 * - missing or empty stored files fall through to the next layer
 * - returns an empty string when every layer resolves to empty content
 */
export async function resolveLocalizationFile(
  { orgId, eventCode = 'global', language, contentId },
  { fetcher = globalThis.fetch, force = false } = {}
) {
  const normalizedLanguage = normalizeLanguage(language);
  const resolvedEventCode = eventCode || 'global';
  const manifest = await fetchLocalizationFilesManifest({ orgId }, { fetcher, force });

  if (resolvedEventCode !== 'global') {
    const eventEntry = getManifestEntry({
      manifest,
      eventCode: resolvedEventCode,
      contentId,
      language: normalizedLanguage,
    });

    if (eventEntry.source === LOCALIZATION_FILE_SOURCE_FILE) {
      const eventValue = await fetchStoredLocalizationFile(
        { orgId, eventCode: resolvedEventCode, language: normalizedLanguage, contentId },
        { fetcher, force }
      );

      if (hasResolvedLocalizationFileContent(eventValue)) {
        return eventValue;
      }
    }
  }

  const globalEntry = getManifestEntry({
    manifest,
    eventCode: 'global',
    contentId,
    language: normalizedLanguage,
  });

  if (globalEntry.source === LOCALIZATION_FILE_SOURCE_FILE) {
    const globalValue = await fetchStoredLocalizationFile(
      { orgId, eventCode: 'global', language: normalizedLanguage, contentId },
      { fetcher, force }
    );

    if (hasResolvedLocalizationFileContent(globalValue)) {
      return globalValue;
    }
  }

  return getSystemDefaultLocalizationFile({ contentId, language: normalizedLanguage });
}

export async function hasResolvedLocalizationFile(params, options) {
  const { orgId, eventCode = 'global', language, contentId } = params;

  if (!orgId) {
    return hasResolvedLocalizationFileContent(getSystemDefaultLocalizationFile({ contentId, language }));
  }

  const manifest = await fetchLocalizationFilesManifest({ orgId }, options);
  const resolvedEventCode = eventCode || 'global';

  if (resolvedEventCode !== 'global') {
    const eventEntry = getManifestEntry({ manifest, eventCode: resolvedEventCode, contentId, language });

    if (eventEntry.source === LOCALIZATION_FILE_SOURCE_FILE) {
      return eventEntry.hasContent !== false;
    }
  }

  const globalEntry = getManifestEntry({ manifest, eventCode: 'global', contentId, language });

  if (globalEntry.source === LOCALIZATION_FILE_SOURCE_FILE) {
    return globalEntry.hasContent !== false;
  }

  return hasResolvedLocalizationFileContent(getSystemDefaultLocalizationFile({ contentId, language }));
}

export function hasResolvedLocalizationFileContent(content = '') {
  return content.trim() !== '';
}

export function resetLocalizationFilesCache({ orgId } = {}) {
  if (!orgId) {
    manifestCache.clear();
    localizationFileCache.clear();
    return;
  }

  const orgPrefix = `${orgId}:`;
  manifestCache.delete(String(orgId));

  Array.from(localizationFileCache.keys()).forEach((cacheKey) => {
    if (cacheKey.startsWith(orgPrefix)) {
      localizationFileCache.delete(cacheKey);
    }
  });
}

function getScopePath(eventCode = 'global') {
  return eventCode === 'global' ? 'global' : `events/${eventCode}`;
}

function normalizeLanguage(language = 'en') {
  return `${language || 'en'}`.split('-')[0];
}

function parseStoredLocalizationFile(rawBody = '') {
  if (typeof rawBody !== 'string' || rawBody.trim() === '') {
    return '';
  }

  try {
    const parsed = JSON.parse(rawBody);

    if (typeof parsed === 'string') {
      return parsed;
    }

    if (parsed && typeof parsed.content === 'string') {
      return parsed.content;
    }
  } catch (_error) {
    return rawBody;
  }

  return '';
}

function normalizeManifest(manifest = {}) {
  if (!manifest || typeof manifest !== 'object' || Array.isArray(manifest)) {
    return {};
  }

  return normalizeFlatManifest(manifest);
}

function normalizeFlatManifest(manifest = {}) {
  const normalizedManifest = {};

  Object.entries(manifest).forEach(([contentId, scopeMap]) => {
    if (!isPlainObject(scopeMap)) {
      return;
    }

    const normalizedScopeMap = {};

    Object.entries(scopeMap).forEach(([scopeKey, languageMap]) => {
      const normalizedLanguageMap = normalizeLanguageMap(languageMap);

      if (Object.keys(normalizedLanguageMap).length > 0) {
        normalizedScopeMap[scopeKey || 'global'] = normalizedLanguageMap;
      }
    });

    if (Object.keys(normalizedScopeMap).length > 0) {
      normalizedManifest[contentId] = normalizedScopeMap;
    }
  });

  return normalizedManifest;
}

function normalizeLanguageMap(languageMap = {}) {
  if (!isPlainObject(languageMap)) {
    return {};
  }

  const normalizedLanguageMap = {};

  Object.entries(languageMap).forEach(([language, value]) => {
    if (!isPlainObject(value)) {
      return;
    }

    normalizedLanguageMap[normalizeLanguage(language)] = value;
  });

  return normalizedLanguageMap;
}

function isPlainObject(value) {
  return Boolean(value) && typeof value === 'object' && !Array.isArray(value);
}
